module.exports = __webpack_public_path__ + "static/img/banner.dbfd312.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.jpg
// module id = hKcQ
// module chunks = 1